import "./campaigndetailcard.scss";
import DotIndicator from "../dotindicator/dotindicator";
import * as React from "react";
import HorizontalDivider from "../horizontaldivider/horizontaldivider";

export interface ICampaignDetailCard {
    name:string
    body1:string
    body2:string
    link:string
}

const CampaignDetailCard = ({name,body1,body2,link}:ICampaignDetailCard) => {
    return(
        <div className="Campaign-Detail-Card">
            <div className="d-flex flex-column justify-content-center align-items-center gap-2">
                <DotIndicator/>
                <span className="dark-text">{name}</span>
            </div>
            <HorizontalDivider />
            <div className="d-flex flex-column justify-content-center align-items-center">
                <div>
                    <span className="Detail-Title">تاریخ شروع کمپین: </span><span className="Detail-Body pe-1 dark-text">{body1}</span>
                </div>
                <div>
                    <span className="Detail-Title">هزینه کل: </span><span className="Detail-Body pe-1 dark-text">{body2}</span>
                </div>
                <a href={link} className="nav-link red-text pt-2"> مشاهده جزییات</a>
            </div>
        </div>
    );
}

export default CampaignDetailCard